<template>
  <div class="logo" :style="{ width: width }">
    <img class="logo__img" src="../../assets/logo.png" alt="Logo" />
  </div>
</template>

<script>
export default {
  name: "LogoImg",
  props: {
    width: Number,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.logo {
  width: 60px;
  &__img {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 12px;
  }
}
</style>
